import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import  { Accounts } from '../services/api';
import { useAuth } from '../auth/AuthProvider';

function UserSelect({ invoice, setInvoice }) {
  const [users, setUsers] = useState([]);
  const [defaultUserId, setDefaultUserId] = useState(null);
  const { company, isSuperuser, user: authUser } = useAuth();

  useEffect(() => {
    // Leer userData desde localStorage al montar
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setDefaultUserId(user.id);

      // Si aún no se ha seteado signedById, lo seteamos automáticamente
      if (!invoice.signedById) {
        setInvoice((prev) => ({ ...prev, signedById: user.id }));
      }
    }
  }, []);

  useEffect(() => {
    // Obtener lista de usuarios filtrados por la empresa actual
    const fetchUsers = async () => {
      try {
        const params = { active: 'true' };
        if (company && company.id) params.company_id = company.id;
        const { data } = await Accounts.users(params);
        const list = Array.isArray(data) ? data : (data?.results || []);
        // Filtrado de superusers según regla:
        const filtered = (list || []).filter(u => {
          if (!u?.is_superuser) return true;
          return Boolean(isSuperuser && authUser && u.id === authUser.id);
        });
        setUsers(filtered);
      } catch {
        setUsers([]);
      }
    };
    fetchUsers();
  }, [company, isSuperuser, authUser]);

  const handleChange = (event) => {
    const userId = event.target.value;
    setInvoice((prev) => ({ ...prev, signedById: userId }));
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Persona firma</InputLabel>
      <Select
        value={invoice?.signedById || ''}
        onChange={handleChange}
        label="Persona firma"
      >
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            {user.first_name + ' ' + user.last_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default UserSelect;
